import _ from 'lodash'

import { filterKeys } from '../../configuration/filtering'
import { getDestinationMapFromTours } from '../../utilities/content/tours'

export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS'
export const FETCH_DESTINATIONS_SUCCESS = 'FETCH_DESTINATIONS_SUCCESS'
export const FETCH_FAMOUS_ROUTES_SUCCESS = 'FETCH_FAMOUS_ROUTES_SUCCESS'
export const FETCH_NATIONAL_PARKS_SUCCESS = 'FETCH_NATIONAL_PARKS_SUCCESS'
export const FETCH_REGIONS_SUCCESS = 'FETCH_REGIONS_SUCCESS'
export const FETCH_TAXONOMIES_SUCCESS = 'FETCH_TAXONOMIES_SUCCESS'
export const FETCH_TRAINS_SUCCESS = 'FETCH_TRAINS_SUCCESS'
export const FETCH_VACATION_TYPES_SUCCESS = 'FETCH_VACATION_TYPES_SUCCESS'

export const fetchCountries = (tours) => (dispatch) => {
  const destinationCountries = _.flatMap(tours, tour => _.get(tour, `[${filterKeys.countries}]`))
  const uniqueCountries = _.uniq(destinationCountries)
  dispatch({ type: FETCH_COUNTRIES_SUCCESS, payload: _.sortBy(uniqueCountries)})
}

export const fetchDestinations = (tours) => (dispatch) => {
  const destinationMap = getDestinationMapFromTours(tours)
  dispatch({ type: FETCH_DESTINATIONS_SUCCESS, payload: _.map(destinationMap) })
}

export const fetchFamousRoutes = (tours) => (dispatch) => {
  const destinationFamousRoutes = _.flatMap(tours, tour => _.get(tour, `[${filterKeys.famousRoutes}]`))
  const uniqueFamousRoutes = _.uniq(destinationFamousRoutes)
  dispatch({ type: FETCH_FAMOUS_ROUTES_SUCCESS, payload: _.sortBy(uniqueFamousRoutes)})
}

export const fetchNationalParks = (tours) => (dispatch) => {
  const destinationNationalParks = _.flatMap(tours, tour => _.get(tour, `[${filterKeys.nationalParks}]`))
  const uniqueNationalParks = _.uniq(destinationNationalParks)
  dispatch({ type: FETCH_NATIONAL_PARKS_SUCCESS, payload: _.sortBy(uniqueNationalParks)})
}

export const fetchRegions = (tours) => (dispatch) => {
  const destinationRegions = _.flatMap(tours, tour => _.get(tour, `[${filterKeys.regions}]`))
  const uniqueRegions = _.uniq(destinationRegions)
  dispatch({ type: FETCH_REGIONS_SUCCESS, payload: _.sortBy(uniqueRegions)})
}

export const fetchTrains = (tours) => (dispatch) => {
  const destinationTrains = _.flatMap(tours, tour => _.get(tour, `[${filterKeys.trains}]`))
  const uniqueTrains = _.uniq(destinationTrains)
  dispatch({ type: FETCH_TRAINS_SUCCESS, payload: _.sortBy(uniqueTrains)})
}

export const fetchVacationTypes = (tours) => (dispatch) => {
  const destinationVacationTypes = _.flatMap(tours, tour => _.get(tour, `[${filterKeys.vacationTypes}]`))
  const uniqueVacationTypes = _.uniq(destinationVacationTypes)
  dispatch({ type: FETCH_VACATION_TYPES_SUCCESS, payload: _.sortBy(uniqueVacationTypes)})
}

export const fetchContent = (tours) => (dispatch) => {
  dispatch(fetchCountries(tours))
  dispatch(fetchDestinations(tours))
  dispatch(fetchFamousRoutes(tours))
  dispatch(fetchNationalParks(tours))
  dispatch(fetchRegions(tours))
  dispatch(fetchTrains(tours))
  dispatch(fetchVacationTypes(tours))
}
